import { useState, useEffect, useRef } from 'react';

export const useScrollDirection = () => {
  const [shouldShowStickyHeader, setShouldShowStickyHeader] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    /* eslint-disable no-restricted-globals */
    if (typeof window === 'undefined') return undefined;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show sticky header only when scrolling up and not at the top
      // Hide when scrolling down or at the very top of the page
      if (currentScrollY > lastScrollY.current || currentScrollY <= 50) {
        // Scrolling down or at top - header should hide
        setShouldShowStickyHeader(false);
      } else if (currentScrollY < lastScrollY.current && currentScrollY > 50) {
        // Scrolling up and away from top - header should show
        setShouldShowStickyHeader(true);
      }

      lastScrollY.current = currentScrollY;
    };

    // Throttle scroll events for performance
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
    /* eslint-enable no-restricted-globals */
  }, []);

  return { shouldShowStickyHeader };
};
